// Keeps the header's hamburger toggle button in sync with the <mobile-menu>
// section, which lives elsewhere in the DOM (a separate section, so it can
// carry its own single link_list setting) and is opened/closed independently
// via mobile-menu.js.
document.querySelectorAll('[data-mobile-menu-toggle]').forEach((toggle) => {
  const setOpen = (open) => {
    toggle.classList.toggle('header__mobile-toggle--open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  };

  document.addEventListener('mobilemenu:open', () => setOpen(true));
  document.addEventListener('mobilemenu:close', () => setOpen(false));
});
